import { useMemo } from 'react';
import { useUserDocumentSnapshot } from '../../../firebase/firestore/hooks';

export const useUpcomingInterviewsCount = (userId?: string): number | undefined => {
  const user = useUserDocumentSnapshot(userId);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useMemo(() => user?.upcomingInterviewsCount, [user?.upcomingInterviewsCount]);
};
